import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { ApplicationsHero } from "@/components/applications/ApplicationsHero";
import { ApplicationsIntro } from "@/components/applications/ApplicationsIntro";
import { ApplicationsList } from "@/components/applications/ApplicationsList";
import { ApplicationsCTA } from "@/components/applications/ApplicationsCTA";

export default function Applications() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="applications-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <ApplicationsHero />
      <ApplicationsIntro />
      <ApplicationsList />
      <ApplicationsCTA />
      <Footer />
    </div>
  );
}
